'use client'

import { Eye, Trash2, Clock, ChevronDown, ChevronUp } from 'lucide-react'
import Link from '@/modules/shared/components/Link'
import { useState, useEffect } from 'react'
import moment from '@/lib/moment.config'
import { useHsRecentlyViewed } from '@/modules/hs/hooks/useHsRecentlyViewed'
import { removeHsCodeDashes } from '@/lib/utils'

const STORAGE_KEY = 'hs-recently-viewed'
const COLLAPSED_KEY = 'hs-recently-viewed-collapsed'

export default function RecentlyViewedCards() {
  const { items: recentItems } = useHsRecentlyViewed()
  const [collapsed, setCollapsed] = useState(false)

  useEffect(() => {
    const saved = localStorage.getItem(COLLAPSED_KEY)
    if (saved !== null) setCollapsed(saved === 'true')
  }, [])

  const toggleCollapsed = () => {
    const next = !collapsed
    setCollapsed(next)
    localStorage.setItem(COLLAPSED_KEY, String(next))
  }

  const clearHistory = () => {
    if (confirm('Bạn có chắc muốn xóa lịch sử xem?')) {
      localStorage.removeItem(STORAGE_KEY)
      window.location.reload()
    }
  }

  if (recentItems.length === 0) {
    return (
      <div className="recently-viewed-section mt-10">
        <div className="search-section-header">
          <div className="section-title">
            <Eye size={20} />
            <h3>Xem gần đây</h3>
            <span className="count-badge">0 mã</span>
          </div>
        </div>
        <div className="text-sm text-neutral-600">
          Chưa có lịch sử xem. Các mã HS bạn xem sẽ được lưu tại đây.
        </div>
      </div>
    )
  }

  return (
    <div className="recently-viewed-section mt-10">
      <div className="search-section-header">
        <div className="section-title">
          <Eye size={20} />
          <h3>Xem gần đây</h3>
          <span className="count-badge">{recentItems.length} mã</span>
        </div>
        <div className="flex items-center gap-2">
          <button className="clear-history-btn" onClick={toggleCollapsed}>
            {collapsed ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
            {collapsed ? 'Mở rộng' : 'Thu gọn'}
          </button>
          <button className="clear-history-btn" onClick={clearHistory}>
            <Trash2 size={16} />
            Xóa lịch sử
          </button>
        </div>
      </div>

      {!collapsed && (
        <div className="recently-viewed-cards">
          {recentItems.map((item, index) => (
            <Link
              key={`${item.hsCode}-${index}`}
              href={`/chi-tiet-ma-hs/${item.hsCode}`}
              className="recent-card"
            >
              <div className="recent-card-header">
                <span className="recent-code">{item.hsCode}</span>
                <span className="recent-chapter">
                  Chương {item.hsCode.substring(0, 2)}
                </span>
              </div>
              <div className="recent-card-title">{removeHsCodeDashes(item.description)}</div>
              <div className="recent-card-meta">
                <span className="recent-time">
                  <Clock size={10} />
                  {moment(item.timestamp).fromNow()}
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
